var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarIcone)?_c('span',[_c('span',{staticClass:"text-primary ml-1"},[_c('i',{staticClass:"fa fa-info-circle fa-lg icon-button",attrs:{"title":"Detalhar"},on:{"click":function($event){$event.stopPropagation();return _vm.toDetalhar()}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }